import React, {useCallback, useEffect, useState, useContext} from 'react';
import {Popup, confirm, setOptions, Button, Input, Textarea, toast, Checkbox, Select, Datepicker} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview, FormGroupTitle, NavItem, TabNav} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderOperations.css';
import dayjs from "dayjs";
import Empty from "../utils/Empty";
import Truncate from "../utils/Truncate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faXmark,
    faArrowUpShortWide,
    faArrowDownWideShort,
    faLeft,
    faBrowser,
    faMobile,
    faCreditCardFront,
    faLink,
    faBrainCircuit,
    faUser,
    faUserHeadset,
    faEllipsisStrokeVertical,
    faCalendarDays,
    faCalendarDay
} from "@fortawesome/pro-duotone-svg-icons";
import {NetworkContext} from "../utils/NetworkContext";
import Loading from "../utils/Loading";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderOperations({locale, dialog, Dialog, teamtalk, Navigation, width, navigation, configuration}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [logins, setLogins] = useState([]);
    const [sessions, setSessions] = useState([]);
    const [usage, setUsage] = useState([]);
    const [usageSummary, setUsageSummary] = useState({});
    const [errors, setErrors] = useState([]);
    const [error, setError] = useState({});
    const [requests, setRequests] = useState([]);
    const [request, setRequest] = useState({});
    const [accounts, setAccounts] = useState([]);
    const [account, setAccount] = useState({});
    const [date, setDate] = useState(dayjs().format());
    const [range, setRange] = useState('day');
    const [personalitiesData, setPersonalitiesData] = useState({});
    const [personalities, setPersonalities] = useState([]);
    const [personality, setPersonality] = useState({});
    const [personalitiesGroups, setPersonalitiesGroups] = useState([]);
    const [personalitiesGroup, setPersonalitiesGroup] = useState('general');
    const [results, setResults] = useState([]);
    const [reply, setReply] = useState(null);
    const [text, setText] = useState(null);
    const [sort, setSort] = useState(true);
    const [tab, setTab] = useState('general');
    const [nav, setNav] = useState('sessions');
    const [fold, setFold] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listInstance, setListInstance] = useState({});
    const [listInstancePersonalities, setListInstancePersonalities] = useState({});

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Nav = data => {
        setLoading(true);
        setText(null);
        setFold(null);
        setResults([]);
        setDate(dayjs().format());
        setRange('day');

        const message = {
            type: 'wss',
            path: 'operations',
            action: 'get',
            data: {
                navigation: data,
                date: dayjs().format("YYYY-M-D"),
                range: 'day'
            }
        };
        wsCall(message);
    }

    const PickerUpdate = data => {
        setLoading(true);
        const itemDate = dayjs(data).format("YYYY-M-D");
        setDate(dayjs(data).format());

        const message = {
            type: 'wss',
            path: 'operations',
            action: 'get',
            data: {
                navigation: nav,
                date: itemDate,
                range: range
            }
        };
        wsCall(message);
    }

    const AccountSaveCheck = () => {
        const original = nav === 'accounts' ? accounts.find(item => item.name === account.name && item.customer === account.customer) : null;
        const originalPersonality = nav === 'accounts' ? original.personalities.find(item => item.value === personality.value) : personalities.find(item => item.value === personality.value);

        if (!Empty(personality) && nav === 'accounts' &&
            (personality.new || (personality.text !== originalPersonality.text ||
                personality.prompt !== originalPersonality.prompt))) {
            return true;
        } else if (Empty(personality) && nav === 'accounts' &&
            (account.displayName !== original.displayName ||
            account.title !== original.title ||
            account.logo !== original.logo ||
            account.mobile !== original.mobile ||
            account.teamtalk !== original.teamtalk ||
            account.prompt !== original.prompt ||
            account.ui.dashboard.functions !== original.ui.dashboard.functions ||
            account.ui.dashboard.model !== original.ui.dashboard.model ||
            account.ui.dashboard.override !== original.ui.dashboard.override ||
            account.ui.dashboard.system !== original.ui.dashboard.system ||
            account.ui.login.email !== original.ui.login.email ||
            account.ui.login.mobile !== original.ui.login.mobile ||
            account.ui.login.multiple !== original.ui.login.multiple ||
            account.ui.login.forgot !== original.ui.login.forgot ||
            account.ui.login.title !== original.ui.login.title)) {
            return true;
        } else if (!Empty(personality) && nav === 'personalities' &&
            (personality.new || (personality.text !== originalPersonality.text ||
                personality.textES !== originalPersonality.textES ||
                personality.prompt !== originalPersonality.prompt ||
                personality.group !== originalPersonality.group ||
                personality.default !== originalPersonality.default))) {
            return true;
        } else {
            return false;
        }
    }

    const ButtonSave = () => {
        if (nav === 'accounts' && !Empty(personality) && !(personality.prompt && personality.text && personality.value)) {
            toast({message: locale.dashboardHeaderOperations.be, color: 'danger', display: 'bottom', duration: 3000});
        } else if (nav === 'accounts' && !Empty(personality) && personality.prompt && personality.text && personality.value) {
            setLoading(true);
            const item = account;
            item.personalities = personality.new ? item.personalities.push({
                value: personality.value,
                prompt: personality.prompt,
                text: personality.text
            }) : item.personalities.map(item => {
                if (item.value === personality.value) {
                    item.prompt = personality.prompt;
                    item.text = personality.text;
                }
                return item;
            })
            setAccount(item);

            const message = {
                type: 'wss',
                path: 'account-personalities',
                action: 'update',
                data: {
                    account: {
                        name: account.name,
                        customer: account.customer,
                        personalities: item.personalities
                    }
                }
            };
            wsCall(message);
        } else if (nav === 'personalities' && !Empty(personality) && !(personality.group && personality.prompt && personality.text && personality.textES && personality.value)) {
            toast({message: locale.dashboardHeaderOperations.be, color: 'danger', display: 'bottom', duration: 3000});
        } else if (nav === 'personalities' && !Empty(personality) && personality.group && personality.prompt && personality.text && personality.textES && personality.value) {
            setLoading(true);

            const message = {
                type: 'wss',
                path: 'personalities',
                action: 'update',
                data: {
                    personality: personality
                }
            };
            wsCall(message);
        } else if (nav === 'accounts' && Empty(personality)) {

            const message = {
                type: 'wss',
                path: 'account-root',
                action: 'update',
                data: {
                    account: account
                }
            };
            wsCall(message);
        } else if (nav === 'requests' && !Empty(request) && tab === 'reply' && !reply) {
            toast({message: locale.dashboardHeaderOperations.ac, color: 'danger', display: 'bottom', duration: 3000});
        } else if (nav === 'requests' && !Empty(request) && tab === 'reply' && reply) {

            const message = {
                type: 'wss',
                path: 'help-messages',
                action: 'update',
                data: {
                    user: request.user,
                    id: request.id,
                    account: request.account,
                    text: reply,
                    messages: request.messages
                }
            };
            wsCall(message);
        }
    }

    const ButtonBack = () => {
        setDate(dayjs().format());
        setRange('day');

        if ((nav === 'accounts' && !Empty(personality)) || (nav === 'personalities' && !Empty(personality))) {
            setPersonality({});
        } else if (nav === 'accounts' && Empty(personality)) {
            setAccount({});
        } else if (nav === 'errors') {
            setError({});
        } else if (nav === 'requests' && !Empty(request) && tab === 'reply') {
            setTab('general');
        } else if (nav === 'requests' && !Empty(request) && tab !== 'reply') {
            setRequest({});
        }
    }

    const ButtonRange = () => {
        setLoading(true);
        const itemDate = dayjs(date).format("YYYY-M-D");
        const itemRange = range === 'day' ? 'month' : 'day';
        setRange(itemRange);

        const message = {
            type: 'wss',
            path: 'operations',
            action: 'get',
            data: {
                navigation: nav,
                date: itemDate,
                range: itemRange
            }
        };
        wsCall(message);
    }

    const ButtonSort = () => {
        if (results.length !== 0) {
            const array = results;

            if (sort && nav === 'sessions') {
                array.sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
            } else if (sort && (nav === 'requests' || nav === 'errors')) {
                array.sort((a, b) => Number(a.id) - Number(b.id));
            } else if (!sort && nav === 'sessions') {
                array.sort((a, b) => Number(b.timestamp) - Number(a.timestamp));
            } else if (!sort && (nav === 'requests' || nav === 'errors')) {
                array.sort((a, b) => Number(b.id) - Number(a.id));
            }

            setResults(array);
        }

        if ((nav === 'loginsUser' || nav === 'loginsAccount') && logins.length !== 0) {
            const array = logins;

            if (sort) {
                array.sort((a, b) => a.logins.length - b.logins.length);
            } else if (!sort) {
                array.sort((a, b) => b.logins.length - a.logins.length);
            }

            setLogins(array);
        } else if (nav === 'sessions' && sessions.length !== 0) {
            const array = sessions;

            if (sort) {
                array.sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
            } else if (!sort) {
                array.sort((a, b) => Number(b.timestamp) - Number(a.timestamp));
            }

            setSessions(array);
        } else if ((nav === 'usageUser' || nav === 'usageAccount') && usage.length !== 0) {
            const array = usage;

            if (sort) {
                array.sort((a, b) => a.tokensTotal - b.tokensTotal);;
            } else if (!sort) {
                array.sort((a, b) => b.tokensTotal - a.tokensTotal);
            }

            setUsage(array)
        } else if (nav === 'requests' && requests.length !== 0) {
            const array = requests;

            if (sort) {
                array.sort((a, b) => Number(a.id) - Number(b.id));
            } else if (!sort) {
                array.sort((a, b) => Number(b.id) - Number(a.id));
            }

            setRequests(array);
        } else if (nav === 'errors' && errors.length !== 0) {
            const array = errors;

            if (sort) {
                array.sort((a, b) => Number(a.id) - Number(b.id));
            } else if (!sort) {
                array.sort((a, b) => Number(b.id) - Number(a.id));
            }

            setErrors(array);
        }

        if (sort) {
            setSort(false);
        } else {
            setSort(true);
        }
    }

    const ButtonWorkspace = () => {
        let string = null;
        let name = null;

        if (nav === 'error') {
            string = JSON.stringify(error);
            name = error.user + '-' + error.id + '.json';
        } else if (nav === 'request') {
            string = JSON.stringify(request);
            name = request.user + '-' + request.id + '.json'
        }

        const base64String = btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        }));

        if (navigation.card !== 'workspace') {
            Navigation({card: 'workspace'});
        }

        const message = {
            type: 'wss',
            path: 'workspace-file',
            action: 'put',
            data: {
                file: `data:application/json;base64,${base64String}`,
                name: name,
                type: 'application/json',
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonErrorDelete = () => {
        confirm({
            title: locale.dashboardHeaderOperations.e,
            message: locale.dashboardHeaderOperations.f,
            okText: locale.dashboardHeaderOperations.c,
            cancelText: locale.dashboardHeaderOperations.g,
            callback: (res) => {
                if (res) {

                    const message = {
                        type: 'wss',
                        path: 'error',
                        action: 'delete',
                        data: {
                            user: error.user,
                            id: error.id
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const ButtonRequestReply = () => {
        setReply(null);
        setTab('reply');
    }

    const ButtonAddPersonality = () => {
        setPersonality({new: true, prompt: null, text: null, value: null});
    }

    const Fold = data => {

        if (fold && fold === data) {
            setFold(null);
        } else if (fold && fold !== data) {
            setFold(data);
        } else if (!fold && data) {
            setFold(data)
        }
    }

    const ListItem = data => {

        if (nav === 'loginsUser') {
            const id = data.item.user + '-' + data.item.account;

            return <li data-id={id} className="cs-dashboard-header-operations-list-multi">
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div>
                        <div className="mbsc-bold mbsc-txt-muted">
                            {data.item.user} ({data.item.logins.length})
                        </div>
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.timezone}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.account}</span>
                        </div>
                        {range === 'day' &&
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                {data.item.logins.map((item, index) => {
                                    return <>
                                        <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{item.login}</span>
                                        {data.item.timezone !== item.timezone &&
                                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >@ {item.timezone}</span>
                                        }
                                        {((index + 1) !== data.item.logins.length) &&
                                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                        }
                                    </>;
                                })}
                            </div>
                        }
                    </div>
                </div>
            </li>;
        } else if (nav === 'loginsAccount') {
            const id = data.item.account;

            return <li data-id={id} className="cs-dashboard-header-operations-list-multi">
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div>
                        <div className="mbsc-bold mbsc-txt-muted">
                            {data.item.account} ({data.item.logins.reduce((sum, l) => sum + l.quantity, 0)})
                        </div>
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            {data.item.logins.map((item, index) => {
                                return <>
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{item.user} ({item.quantity})</span>
                                    {((index + 1) !== data.item.logins.length) &&
                                        <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    }
                                </>;
                            })}
                        </div>
                    </div>
                </div>
            </li>;
        } else if (nav === 'sessions') {
            const itemDate = dayjs(parseInt(data.item.timestamp)).format("MMMM D, YYYY @ h:mm A");
            const itemDateSmall = dayjs(parseInt(data.item.timestamp)).format("DD-MM-YYYY @ h:mm A");
            const id = data.item.user + '-' + data.item.timestamp.toString();

            return <li data-id={id} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    {data.item.type === 'webapp' && width > 576 &&
                        <FontAwesomeIcon className="cs-dashboard-header-operations-icon-large" icon={faBrowser} />
                    }
                    {data.item.type === 'mobile' && width > 576 &&
                        <FontAwesomeIcon className="cs-dashboard-header-operations-icon-large" icon={faMobile} />
                    }
                    <div>
                        <div className="mbsc-bold mbsc-txt-muted">
                            {data.item.user}
                        </div>
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{width > 576 ? itemDate : itemDateSmall}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.account}</span>
                        </div>
                    </div>
                </div>
            </li>;
        } else if (nav === 'usageUser') {
            const id = data.item.user + '-' + data.item.model + '-' + data.item.account;

            return <li data-id={id} className="cs-dashboard-header-operations-list-multi" onClick={() => Fold(id)} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div>
                        <div className="mbsc-txt-muted">
                            <span className="mbsc-bold">{data.item.user}</span><span className="mbsc-bold cs-dashboard-header-operations-button-nav">&nbsp;|&nbsp;</span>{data.item.model}
                        </div>
                        {fold === id &&
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text">{data.item.account}</span>
                            </div>
                        }
                        {data.item.itemOutput !== 0 ?
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">📦&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.itemOutput.toLocaleString('en-US')}</span>
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                            :
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">👁&nbsp;</span>
                                }
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensImage.toLocaleString('en-US')}</span>
                                }
                                {data.item.tokensImage !== 0 && fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {data.item.tokensImage !== 0 && fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensImageCost.toFixed(2)}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav">{data.item.tokensImage !== 0 && '\u00A0\u00A0'}⬇&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensInput.toLocaleString('en-US')}</span>
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensInputCost.toFixed(2)}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav">&nbsp;&nbsp;⬆&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensOutput.toLocaleString('en-US')}</span>
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensOutputCost.toFixed(2)}</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-text" >&nbsp;&nbsp;⨊&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensTotal.toLocaleString('en-US')}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                        }
                    </div>
                </div>
            </li>;
        } else if (nav === 'usageAccount') {
            const id = data.item.account + '-' + data.item.model;

            return <li data-id={id} className="cs-dashboard-header-operations-list-multi" onClick={() => Fold(id)} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div>
                        <div className="mbsc-txt-muted">
                            <span className="mbsc-bold">{data.item.account}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-button-nav">&nbsp;|&nbsp;</span>
                            {data.item.model}
                        </div>
                        {data.item.itemOutput !== 0 ?
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">📦&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.itemOutput.toLocaleString('en-US')}</span>
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                            :
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav">👁&nbsp;</span>
                                }
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensImage.toLocaleString('en-US')}</span>
                                }
                                {data.item.tokensImage !== 0 && fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {data.item.tokensImage !== 0 && fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensImageCost.toFixed(2)}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav">{data.item.tokensImage !== 0 && '\u00A0\u00A0'}⬇&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensInput.toLocaleString('en-US')}</span>
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensInputCost.toFixed(2)}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav">&nbsp;&nbsp;⬆&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensOutput.toLocaleString('en-US')}</span>
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon" >&nbsp;@&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensOutputCost.toFixed(2)}</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-text" >&nbsp;&nbsp;⨊&nbsp;</span>
                                }
                                {fold === id &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensTotal.toLocaleString('en-US')}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-operations-accounts-list-icon">&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                        }

                    </div>
                </div>
            </li>;
        } else if (Empty(account) && nav === 'accounts') {
            const name = data.item.name + '-' + data.item.customer;
            const status =  data.item.billing.status.charAt(0).toUpperCase() + data.item.billing.status.slice(1);
            const plan = data.item.billing.plan.charAt(0).toUpperCase() + data.item.billing.plan.slice(1);
            const users = data.item.billing.users ? data.item.billing.users : 0;

            return <li data-id={name} onClick={() => listInstance.openActions(name, 'left')} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        <div style={data.item.logo ? {backgroundImage: `url(${data.item.logo})`} : {backgroundImage: `url(${configuration.logoCS})`}} className="cs-dashboard-header-operations-accounts-logo"  />
                    </div>
                    <div className="mbsc-col cs-dashboard-header-operations-list-section">
                        <div className="mbsc-bold mbsc-txt-muted">
                            {width < 768 && name && Truncate(name.toUpperCase(), 30)}
                            {width > 768 && name && Truncate(name.toUpperCase(), 60)}
                        </div>
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            <span className={data.item.billing.status === 'active' ? "mbsc-txt-muted cs-dashboard-header-operations-accounts-active" : "mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text"} >{status}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{plan}</span>
                            {users !== 0 &&
                                <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            }
                            {users !== 0 &&
                                <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{users}</span>
                            }
                            {data.item.billing.stripe &&
                                <FontAwesomeIcon className="cs-dashboard-header-operations-icon-small" icon={faCreditCardFront} />
                            }
                            {data.item.type === 'linked' &&
                                <FontAwesomeIcon className="cs-dashboard-header-operations-icon-small" icon={faLink} />
                            }
                        </div>
                    </div>
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        <FontAwesomeIcon className="cs-dashboard-header-operations-list-menu" icon={faEllipsisStrokeVertical} />
                    </div>
                </div>
            </li>;
        } else if (Empty(request) && nav === 'requests') {
            const itemDate = dayjs(parseInt(data.item.id)).format("MMMM D, YYYY @ h:mm A");
            const id = data.item.user + '-' + data.item.id;

            return <li data-id={id} onClick={() => listInstance.openActions(id, 'left')} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div className="mbsc-col cs-dashboard-header-operations-list-item" >
                        <div className="mbsc-bold mbsc-txt-muted">
                            {width < 768 && data.item.request && Truncate(data.item.request, 30)}
                            {width > 768 && data.item.request && Truncate(data.item.request, 60)}
                        </div>
                        <div className="mbsc-row mbsc-txt-muted mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{itemDate}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.user}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.account}</span>
                            {data.item.lastUpdate === 'user' &&
                                <FontAwesomeIcon className="cs-dashboard-header-operations-icon-small" icon={faUser} />
                            }
                            {data.item.lastUpdate === 'specialist' &&
                                <FontAwesomeIcon className="cs-dashboard-header-operations-icon-small" icon={faUserHeadset} />
                            }
                            {data.item.lastUpdate === 'ai' &&
                                <FontAwesomeIcon className="cs-dashboard-header-operations-icon-small" icon={faBrainCircuit} />
                            }
                        </div>
                    </div>
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        <FontAwesomeIcon className="cs-dashboard-header-operations-list-menu" icon={faEllipsisStrokeVertical} />
                    </div>
                </div>
            </li>;
        } else if (!Empty(request) && nav === 'requests') {
            const itemDate = dayjs(parseInt(data.item.timestamp)).format("YYYY-MM-DD @ h:mm A");
            const role =  data.item.role.charAt(0).toUpperCase() + data.item.role.slice(1);
            const id = data.item.timestamp;

            return <li data-id={id} >
                <div className="mbsc-bold mbsc-txt-muted">
                    {role} @ {itemDate}
                </div>
                <Textarea
                    inputStyle="underline"
                    className="cs-dashboard-header-operations-message-text"
                    rows={3}
                    value={data.item.text}
                    disabled
                />
            </li>;
        } else if (nav === 'errors') {
            const itemDate = dayjs(parseInt(data.item.id)).format("YYYY-MM-DD @ h:mm A");
            const id = data.item.user + '-' + data.item.id;

            return <li data-id={id} onClick={() => listInstance.openActions(id, 'left')} >
                <div className="mbsc-row cs-dashboard-header-operations-list" >
                    <div className="mbsc-col cs-dashboard-header-operations-list-item" >
                        <div className="mbsc-bold mbsc-txt-muted">
                            {width < 768 && data.item.error && Truncate(data.item.error, 30)}
                            {width > 768 && data.item.error && Truncate(data.item.error, 60)}
                        </div>
                        <div className="mbsc-row mbsc-txt-muted mbsc-txt-s cs-dashboard-header-operations-item-txt">
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{itemDate}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.user}</span>
                            <span className="mbsc-bold cs-dashboard-header-operations-divider">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.account}</span>
                        </div>
                    </div>
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        <FontAwesomeIcon className="cs-dashboard-header-operations-list-menu" icon={faEllipsisStrokeVertical} />
                    </div>
                </div>
            </li>;
        } else if ((!Empty(account) && nav === 'accounts') || nav === 'personalities') {
            const id = data.item.value;

            return <li data-id={id} >
                <div className="mbsc-row cs-dashboard-header-operations-list" onClick={() => nav === 'personalities' ? listInstance.openActions(data.item.value, 'left') : listInstancePersonalities.openActions(data.item.value, 'left')} >
                    <div className="mbsc-col cs-dashboard-header-operations-list-item" >
                        <div className="cs-dashboard-header-operations-list-section-personality">
                            <div className={data.item.default ? "mbsc-bold mbsc-txt-muted cs-dashboard-header-operations-button" : "mbsc-bold mbsc-txt-muted"}>
                                {data.item.text}
                            </div>
                        </div>
                    </div>
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        <FontAwesomeIcon className="cs-dashboard-header-operations-list-menu" icon={faEllipsisStrokeVertical} />
                    </div>
                </div>
            </li>;
        }
    }

    const ListData = () => {
        if (nav === 'loginsUser' || nav === 'loginsAccount') {
            return logins;
        } else if (nav === 'sessions') {
            return text ? results : sessions;
        } else if (nav === 'usageUser' || nav === 'usageAccount') {
            return usage;
        } else if (Empty(account) && nav === 'accounts') {
            return text ? results : accounts;
        } else if (Empty(request) && nav === 'requests') {
            return text ? results : requests;
        } else if (nav === 'errors') {
            return text ? results : errors;
        } else if (!Empty(request) && nav === 'requests') {
            return request.messages;
        } else if (!Empty(account) && nav === 'accounts') {
            return personalities;
        } else if (nav === 'personalities') {
            return text ? results : personalities;
        }
    }

    const ListActions = () => {
        if (Empty(account) && nav === 'accounts') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.x,
                    action: (event, inst) => {
                        const item = accounts[event.index];

                        setText(null);
                        setResults([]);
                        setTab('general');
                        setAccount(item);

                        setPersonalities((item.personalities && item.personalities.length !== 0) ? item.personalities : []);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.d,
                    action: (event, inst) => {
                        const item = accounts[event.index];
                        const string = JSON.stringify(accounts[event.index]);

                        const base64String = btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                            return String.fromCharCode(parseInt(p1, 16));
                        }));

                        if (navigation.card !== 'workspace') {
                            Navigation({card: 'workspace'});
                        }

                        const message = {
                            type: 'wss',
                            path: 'workspace-file',
                            action: 'put',
                            data: {
                                file: `data:application/json;base64,${base64String}`,
                                name: item.name + '-' + item.customer + '.json',
                                type: 'application/json',
                                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                            }
                        };
                        wsCall(message);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.c,
                    action: (event, inst) => {
                        const item = accounts[event.index];

                        confirm({
                            title: locale.dashboardHeaderOperations.bx + ' ' + item.name.toUpperCase() + '-' + item.customer.toUpperCase(),
                            message: locale.dashboardHeaderOperations.by,
                            okText: locale.dashboardHeaderOperations.c,
                            cancelText: locale.dashboardHeaderOperations.g,
                            callback: (res) => {
                                if (res) {
                                    setLoading(true);
                                    const array = accounts.filter(itemArray => item.value !== itemArray.value);
                                    setAccounts(array);

                                    const message = {
                                        type: 'wss',
                                        path: 'account',
                                        action: 'delete',
                                        data: {
                                            account: item
                                        }
                                    };
                                    wsCall(message);
                                } else {
                                    inst.close(event.target);
                                }
                            }
                        });
                        return false;
                    }
                }]
            };
        } else if (nav === 'requests') {
           return {
               right: [{
                   color: '#0B7DBB',
                   text: locale.dashboardHeaderOperations.x,
                   action: (event, inst) => {
                       const item = requests[event.index];
                       item.messages = item.messages.reverse();
                       setRequest(item);

                       return false;
                   }
               }, {
                   color: '#0B7DBB',
                   text: locale.dashboardHeaderOperations.d,
                   action: (event, inst) => {
                       const item = requests[event.index];
                       const string = JSON.stringify(requests[event.index]);

                       const base64String = btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                           return String.fromCharCode(parseInt(p1, 16));
                       }));

                       if (navigation.card !== 'workspace') {
                           Navigation({card: 'workspace'});
                       }

                       const message = {
                           type: 'wss',
                           path: 'workspace-file',
                           action: 'put',
                           data: {
                               file: `data:application/json;base64,${base64String}`,
                               name: item.user + '-' + item.id + '.json',
                               type: 'application/json',
                               teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                               tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                           }
                       };
                       wsCall(message);

                       return false;
                   }
               }, {
                   color: '#0B7DBB',
                   text: locale.dashboardHeaderOperations.u,
                   action: (event, inst) => {
                       confirm({
                           title: locale.dashboardHeaderOperations.v,
                           message: locale.dashboardHeaderOperations.w,
                           okText: locale.dashboardHeaderOperations.u,
                           cancelText: locale.dashboardHeaderOperations.g,
                           callback: (res) => {
                               if (res) {
                                   const item = requests[event.index];

                                   const message = {
                                       type: 'wss',
                                       path: 'help-status',
                                       action: 'update',
                                       data: {
                                           user: item.user,
                                           id: item.id,
                                           account: item.account,
                                           status: 'closed'
                                       }
                                   };
                                   wsCall(message);
                               } else {
                                   inst.close(event.target);
                               }
                           }
                       });
                       return false;
                   }
               }]
           };
        } else if (nav === 'errors') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.x,
                    action: (event, inst) => {
                        const item = errors[event.index];
                        setError(item);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.d,
                    action: (event, inst) => {
                        const item = errors[event.index];
                        const string = JSON.stringify(errors[event.index]);

                        const base64String = btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                            return String.fromCharCode(parseInt(p1, 16));
                        }));

                        if (navigation.card !== 'workspace') {
                            Navigation({card: 'workspace'});
                        }

                        const message = {
                            type: 'wss',
                            path: 'workspace-file',
                            action: 'put',
                            data: {
                                file: `data:application/json;base64,${base64String}`,
                                name: item.user + '-' + item.id + '.json',
                                type: 'application/json',
                                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                            }
                        };
                        wsCall(message);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.c,
                    action: (event, inst) => {
                        confirm({
                            title: locale.dashboardHeaderOperations.e,
                            message: locale.dashboardHeaderOperations.f,
                            okText: locale.dashboardHeaderOperations.c,
                            cancelText: locale.dashboardHeaderOperations.g,
                            callback: (res) => {
                                if (res) {
                                    const item = errors[event.index];

                                    const message = {
                                        type: 'wss',
                                        path: 'error',
                                        action: 'delete',
                                        data: {
                                            user: item.user,
                                            id: item.id
                                        }
                                    };
                                    wsCall(message);
                                } else {
                                    inst.close(event.target);
                                }
                            }
                        });
                        return false;
                    }
                }]
            };
        } else if (!Empty(account) && nav === 'accounts') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.j,
                    action: (event, inst) => {
                        const item = personalities[event.index];

                        setPersonality(item);

                        return false;
                    }
                },{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.c,
                    action: (event, inst) => {
                        confirm({
                            title: locale.dashboardHeaderOperations.bc,
                            message: locale.dashboardHeaderOperations.f,
                            okText: locale.dashboardHeaderOperations.c,
                            cancelText: locale.dashboardHeaderOperations.g,
                            callback: (res) => {
                                if (res) {
                                    setLoading(true);
                                    const item = personalities[event.index];
                                    const array = personalities.filter(itemArray => item.value !== itemArray.value);
                                    setPersonalities(array);

                                    const message = {
                                        type: 'wss',
                                        path: 'account-personalities',
                                        action: 'update',
                                        data: {
                                            account: {
                                                name: account.name,
                                                customer: account.customer,
                                                personalities: array
                                            }
                                        }
                                    };
                                    wsCall(message);
                                } else {
                                    inst.close(event.target);
                                }
                            }
                        });
                        return false;
                    }
                }]
            };
        } else if (nav === 'personalities') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.j,
                    action: (event, inst) => {
                        const item = personalities[event.index];

                        setPersonality(item);

                        return false;
                    }
                },{
                    color: '#0B7DBB',
                    text: locale.dashboardHeaderOperations.c,
                    action: (event, inst) => {
                        confirm({
                            title: locale.dashboardHeaderOperations.bc,
                            message: locale.dashboardHeaderOperations.f,
                            okText: locale.dashboardHeaderOperations.c,
                            cancelText: locale.dashboardHeaderOperations.g,
                            callback: (res) => {
                                if (res) {
                                    setLoading(true);
                                    const item = personalities[event.index];
                                    const array = personalities.filter(itemArray => item.value !== itemArray.value);
                                    setPersonalities(array);

                                    const message = {
                                        type: 'wss',
                                        path: 'account-personalities',
                                        action: 'update',
                                        data: {
                                            account: {
                                                name: account.name,
                                                customer: account.customer,
                                                personalities: array
                                            }
                                        }
                                    };
                                    wsCall(message);
                                } else {
                                    inst.close(event.target);
                                }
                            }
                        });
                        return false;
                    }
                }]
            };
        } else {
            return {};
        }
    }

    const InputSuggestion = data => {
        setText(data);
        const query = data.trim().toLowerCase();
        let filtered = null;

        if (!query) {
            setResults([]);
            return;
        }

        if (nav === 'sessions') {
            filtered = sessions.filter(item =>
                (item.user.toLowerCase().includes(query) || item.account.toLowerCase().includes(query))
            );
        } else if (nav === 'accounts') {
            filtered = accounts.filter(item =>
                (item.name.toLowerCase().includes(query) || item.displayName.toLowerCase().includes(query) || item.customer.toLowerCase().includes(query))
            );
        } else if (nav === 'requests') {
            filtered = requests.filter(item =>
                item.request.toLowerCase().includes(query)
            );
        } else if (nav === 'errors') {
            filtered = errors.filter(item =>
                item.error.toLowerCase().includes(query)
            );
        } else if (nav === 'personalities') {
            filtered = personalities.filter(item =>
                item.text.toLowerCase().includes(query)
            );
        }

        setResults(filtered);
    }

    const InputAccountSave = data => {
        const item = {...account};

        if (data.displayName) {
            item.displayName = data.displayName;
        } else if (data.title) {
            item.title = data.title;
        } else if (data.logo) {
            item.logo = data.logo;
        } else if (data.mobile) {
            item.mobile = data.mobile;
        } else if (data.teamtalk) {
            item.teamtalk = data.teamtalk;
        } else if (data.prompt) {
            item.prompt = data.prompt;
        } else if (data.uiDashboardFunctions) {
            item.ui.dashboard.functions = data.uiDashboardFunctions;
        } else if (data.uiDashboardModel) {
            item.ui.dashboard.model = data.uiDashboardModel;
        } else if (data.uiDashboardOverride) {
            item.ui.dashboard.override = data.uiDashboardOverride;
        } else if (data.uiDashboardSystem) {
            item.ui.dashboard.system = data.uiDashboardSystem;
        } else if (data.uiLoginEmail) {
            item.ui.login.email = data.uiLoginEmail;
        } else if (data.uiLoginMobile) {
            item.ui.login.mobile = data.uiLoginMobile;
        } else if (data.uiLoginMultiple) {
            item.ui.login.multiple = data.uiLoginMultiple;
        } else if (data.uiLoginForgot) {
            item.ui.login.forgot = data.uiLoginForgot;
        } else if (data.uiLoginTitle) {
            item.ui.login.title = data.uiLoginTitle;
        }

        setAccount(item);
    }

    const InputPersonalitySave = data => {
        const item = {...personality};

        if (data.value) {
            item.value = data.value;
        } else if (data.text) {
            item.text = data.text;
        } else if (data.prompt) {
            item.prompt = data.prompt;
        } else if (data.group) {
            item.group = data.group;
        } else if (data.default === true || data.default === false) {
            item.default = data.default;
        } else if (data.textES) {
            item.textES = data.textES;
        }

        setPersonality(item);
    }

    const SelectGroup = data => {
        setPersonalitiesGroup(data);
        setPersonalities(personalitiesData[data]);
    }

    const GetOperations = useCallback(data => {
        if (data.logins) {
            let array = [];
            if (data.logins.length !== 0) {
                array = data.logins.sort((a, b) => b.logins.length - a.logins.length);
            }
            setLogins(array);
        }
        if (data.sessions) {
            let array = [];
            if (data.sessions.length !== 0) {
                array = data.sessions.sort((a, b) => Number(b.timestamp) - Number(a.timestamp));
            }
            setSessions(array);
        }
        if (data.usage) {
            let array = [];
            if (data.usage.length !== 0) {
                array = data.usage.sort((a, b) => b.tokensTotal - a.tokensTotal);
            }
            setUsage(array);
        }
        if (data.personalitiesData && data.personalitiesGroups) {
            setPersonalitiesData(data.personalitiesData);
            setPersonalitiesGroups(data.personalitiesGroups);
            setPersonalities(data.personalitiesData['general']);
        }
        if (data.summary) {
            setUsageSummary(data.summary);
        }
        if (data.errors) {
            let array = [];
            if (data.errors.length !== 0) {
                array = data.errors.sort((a, b) => Number(b.id) - Number(a.id));

                array = data.errors.map(item => {
                    if (!item.error) {
                        item.error = locale.dashboardHeaderOperations.q;
                    }
                    return item
                })
            }
            setErrors(array);
        }
        if (data.requests) {
            let array = [];
            if (data.requests.length !== 0) {
                array = data.requests.sort((a, b) => Number(b.id) - Number(a.id));
            }
            setRequests(array);
        }
        if (data.accounts) {
            setAccounts(data.accounts);
        }
        if (data.navigation && data.navigation !== nav) {
            setNav(data.navigation);
        }
        setLoading(false);
    }, [locale.dashboardHeaderOperations.q, nav]);

    const DeleteError = useCallback(data => {
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.t, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.errors) {
            setError({});
            let array = [];
            if (data.errors.length !== 0) {
                array = data.errors.sort((a, b) => Number(b.id) - Number(a.id));

                array = data.errors.map(item => {
                    if (!item.error) {
                        item.error = locale.dashboardHeaderOperations.q;
                    }
                    return item
                })
            }
            setErrors(array);
            if (nav === 'error') {
                setNav('errors');
            }
        }
    }, [nav, locale.dashboardHeaderOperations.t, locale.dashboardHeaderOperations.q]);

    const DeleteAccount = useCallback(data => {
        setLoading(false);
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.bw, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [locale.dashboardHeaderOperations.bw]);

    const UpdateHelpMessages = useCallback(data => {
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.ab, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.messages) {
            const item = request;
            item.messages = data.messages;

            setRequest(item);
            setTab('general');
        }
    }, [locale.dashboardHeaderOperations.ab, request]);

    const UpdateHelpStatus = useCallback(data => {
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.ab, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [locale.dashboardHeaderOperations.ab]);

    const UpdateAccountRoot = useCallback(data => {
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.bw, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [locale.dashboardHeaderOperations.bw]);

    const UpdateAccountPersonalities = useCallback(data => {
        if (data.toast) {
            toast({message: locale.dashboardHeaderOperations.bw, color: 'info', display: 'bottom', duration: 1000});
        }
        setPersonality({});
        setLoading(false);
    }, [locale.dashboardHeaderOperations.bw, DialogClose]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'operations') {
            GetOperations(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetOperations, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'error') {
            DeleteError(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteError, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'account') {
            DeleteAccount(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteAccount, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'help-messages') {
            UpdateHelpMessages(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateHelpMessages, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'help-status') {
            UpdateHelpStatus(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateHelpStatus, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'account-root') {
            UpdateAccountRoot(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateAccountRoot, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'account-personalities') {
            UpdateAccountPersonalities(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateAccountPersonalities, setWsResponse]);

    useEffect(() => {
        Nav('sessions');
    }, []);

    return (
        <Popup className="cs-dashboard-header-operations-popup" width={600} scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} display="center" maxHeight="700" buttons={[]} isOpen={dialog.view === 'dashboardHeaderOperations'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-operations-header-col">
                <div className="mbsc-row cs-dashboard-header-operations-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-operations-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-operations-header-col mbsc-align-center cs-dashboard-header-operations-header-select" : "mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-header-select"} >
                        <Select
                            animation="slide-down"
                            inputStyle="underline"
                            rows={locale.dashboardHeaderOperations.b.length}
                            display="anchored"
                            touchUi={false}
                            data={locale.dashboardHeaderOperations.b}
                            value={nav}
                            onChange={args => Nav(args.value)}
                        />
                    </div>
                    <div className="mbsc-col cs-dashboard-header-operations-header-col mbsc-align-right">
                        {(nav === 'error' || nav === 'request') &&
                            <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-button" onClick={() => ButtonBack()} >
                                &nbsp;<FontAwesomeIcon className="cs-dashboard-header-operations-close-icon" icon={faLeft} />
                            </Button>
                        }
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-button" onClick={() => DialogClose()} >
                            {'\u00A0'}<FontAwesomeIcon className="cs-dashboard-header-operations-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {loading &&
                <Loading />
            }
            {!loading && Empty(account) && Empty(error) && Empty(request) && Empty(personality) && (nav === 'loginsUser' || nav === 'loginsAccount' || nav === 'sessions' || nav === 'usageUser' || nav === 'usageAccount' || nav === 'accounts' || nav === 'requests' || nav === 'errors' || nav === 'personalities') &&
                <>
                    <div className="mbsc-grid cs-dashboard-header-operations-header-col">
                        <div className="mbsc-row cs-dashboard-header-operations-header-row">
                            {(nav === 'loginsUser' || nav === 'loginsAccount' || nav === 'usageUser' || nav === 'usageAccount') &&
                                <div className="mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-border" >
                                    <Button color="primary" variant="flat" className="cs-dashboard-header-operations-picker cs-dashboard-header-operations-button mbsc-bold mbsc-txt-muted" >
                                        <Datepicker
                                            controls={['date']}
                                            touchUi={width <= 576}
                                            value={date}
                                            inputComponent="input"
                                            max={dayjs().format()}
                                            dateFormat={range === 'day' ? "YYYY-M-D" : "YYYY-M"}
                                            dateWheels={range === 'day' ? "|YYYY | MMM | D|" : "|YYYY | MMM|"}
                                            buttons={['set', 'cancel']}
                                            onChange={ev => PickerUpdate(ev.value)}
                                            setText={locale.dashboardHeaderOperations.x}
                                            cancelText={locale.dashboardHeaderOperations.g}
                                        />
                                    </Button>
                                </div>
                            }
                            {(nav === 'sessions' || nav === 'accounts' || nav === 'requests' || nav === 'errors') &&
                                <div className="mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-select" >
                                    <Input
                                        inputStyle="underline"
                                        placeholder={locale.dashboardHeaderOperations.m}
                                        labelStyle="floating"
                                        type="text"
                                        name="search"
                                        value={text}
                                        onChange={ev => InputSuggestion(ev.target.value)}
                                    />
                                </div>
                            }
                            {nav === 'personalities' &&
                                <div className="mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-select" >
                                    <Select
                                        animation="slide-down"
                                        inputStyle="underline"
                                        label={locale.dashboardHeaderOperations.ca}
                                        labelStyle="floating"
                                        touchUi={false}
                                        rows={personalitiesGroups.length}
                                        display="anchored"
                                        data={personalitiesGroups}
                                        value={personalitiesGroup}
                                        onChange={args => SelectGroup(args.value)}
                                    />
                                </div>
                            }
                            <div className="mbsc-col-auto cs-dashboard-header-operations-col-sort" >
                                {(nav === 'loginsUser' || nav === 'loginsAccount' || nav === 'usageUser' || nav === 'usageAccount') &&
                                    <Button className="mbsc-bold" variant="flat" onClick={() => ButtonRange()} >
                                        <FontAwesomeIcon className="cs-dashboard-header-operations-sort-button" icon={range === 'day' ? faCalendarDays : faCalendarDay} />
                                    </Button>
                                }
                                {(nav === 'loginsUser' || nav === 'loginsAccount' || nav === 'sessions' || nav === 'usageUser' || nav === 'usageAccount' || nav === 'requests' || nav === 'errors') &&
                                    <Button className="mbsc-bold" variant="flat" onClick={() => ButtonSort()} >
                                        <FontAwesomeIcon className="cs-dashboard-header-operations-sort-button" icon={sort ? faArrowDownWideShort : faArrowUpShortWide} />
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                    {(nav === 'usageUser' || nav === 'usageAccount') && fold === 'summary' &&
                        <div className="mbsc-grid cs-dashboard-header-operations-header-col" onClick={() => Fold('summary')}>
                            <div className="mbsc-row cs-dashboard-header-operations-header-row">
                                <div className="mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-select">
                                    <Button color="primary" variant="flat" className="cs-dashboard-header-operations-button-summary mbsc-txt-muted" >
                                        <span>📦&nbsp;${usageSummary.itemCost.toFixed(2)}</span>
                                        <span>&nbsp;&nbsp;👁&nbsp;${usageSummary.tokensImageCost.toFixed(2)}</span>
                                        <span>&nbsp;&nbsp;⬇&nbsp;${usageSummary.tokensInputCost.toFixed(2)}</span>
                                        <span>&nbsp;&nbsp;⬆&nbsp;${usageSummary.tokensOutputCost.toFixed(2)}</span>
                                        <span className="mbsc-bold" >&nbsp;&nbsp;∑&nbsp;${usageSummary.tokensTotalCost.toFixed(2)}</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                    {(nav === 'usageUser' || nav === 'usageAccount') &&
                        <div className="mbsc-grid cs-dashboard-header-operations-header-col" onClick={() => Fold('summary')}>
                            <div className="mbsc-row cs-dashboard-header-operations-header-row">
                                <div className="mbsc-col cs-dashboard-header-operations-header-col cs-dashboard-header-operations-select">
                                    <Button color="primary" variant="flat" className="cs-dashboard-header-operations-button-summary mbsc-txt-muted" >
                                        <span>📦&nbsp;{usageSummary.itemOutput.toLocaleString('en-US')}</span>
                                        <span>&nbsp;&nbsp;👁&nbsp;{usageSummary.tokensImage.toLocaleString('en-US')}</span>
                                        <span>&nbsp;&nbsp;⬇&nbsp;{usageSummary.tokensInput.toLocaleString('en-US')}</span>
                                        <span>&nbsp;&nbsp;⬆&nbsp;{usageSummary.tokensOutput.toLocaleString('en-US')}</span>
                                        {fold === 'summary' ?
                                            <span className="mbsc-bold" >&nbsp;&nbsp;∑&nbsp;{usageSummary.tokensTotal.toLocaleString('en-US')}</span> :
                                            <span className="mbsc-bold" >&nbsp;&nbsp;@&nbsp;${usageSummary.tokensTotalCost.toFixed(2)}</span>
                                        }
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className={(nav === 'usageUser' || nav === 'usageAccount') ? "cs-dashboard-header-operations-scroll-personality" : "cs-dashboard-header-operations-scroll"}>
                        <Listview
                            theme="ios"
                            themeVariant="light"
                            select="single"
                            itemType={ListItem}
                            data={ListData()}
                            onInit={(event, inst) => setListInstance(inst)}
                            actionsWidth={100}
                            actions={ListActions()}
                        />
                    </div>
                </>
            }
            {!loading && !Empty(account) && Empty(personality) && nav === 'accounts' &&
                <>
                    <TabNav theme="mobiscroll" themeVariant="light" display='inline' className="cs-dashboard-header-operations-nav-tab" >
                        <NavItem selected={tab === 'general'} onClick={() => tab !== 'general' && setTab('general')} >
                            <span className={tab === 'general' ? 'mbsc-bold cs-dashboard-header-operations-button-nav' : ''} >{locale.dashboardHeaderOperations.ae}</span>
                        </NavItem>
                        <NavItem selected={tab === 'prompt'} onClick={() => tab !== 'prompt' && setTab('prompt')} >
                            <span className={tab === 'prompt' ? 'mbsc-bold cs-dashboard-header-operations-button-nav' : ''} >{locale.dashboardHeaderOperations.al}</span>
                        </NavItem>
                        <NavItem selected={tab === 'ui'} onClick={() => tab !== 'ui' && setTab('ui')} >
                            <span className={tab === 'ui' ? 'mbsc-bold cs-dashboard-header-operations-button-nav' : ''} >{locale.dashboardHeaderOperations.am}</span>
                        </NavItem>
                        <NavItem selected={tab === 'ai'} onClick={() => tab !== 'ai' && setTab('ai')} >
                            <span className={tab === 'ai' ? 'mbsc-bold cs-dashboard-header-operations-button-nav' : ''} >{locale.dashboardHeaderOperations.az}</span>
                        </NavItem>
                        <NavItem selected={tab === 'billing'} onClick={() => tab !== 'billing' && setTab('billing')} >
                            <span className={tab === 'billing' ? 'mbsc-bold cs-dashboard-header-operations-button-nav' : ''} >{locale.dashboardHeaderOperations.bh}</span>
                        </NavItem>
                    </TabNav>
                    {tab === 'general' &&
                        <>
                            <FormGroupTitle />
                            <Input
                                label={locale.dashboardHeaderOperations.af}
                                disabled
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.name + '-' + account.customer}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.ak}
                                disabled
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.type.charAt(0).toUpperCase() + account.type.slice(1)}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.ag}
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.displayName}
                                onChange={ev => InputAccountSave({displayName: ev.target.value})}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.ah}
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.title}
                                onChange={ev => InputAccountSave({title: ev.target.value})}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.a}
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.logo}
                                onChange={ev => InputAccountSave({logo: ev.target.value})}
                            />
                            {account.ui.login.mobile &&
                                <Checkbox
                                    cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                    color="info"
                                    label={locale.dashboardHeaderOperations.ai}
                                    checked={account.mobile}
                                    position="start"
                                    onChange={ev => InputAccountSave({mobile: ev.target.checked})}
                                />
                            }
                            {account.billing.plan !== 'personal' &&
                                <Checkbox
                                    cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                    color="info"
                                    label={locale.dashboardHeaderOperations.aj}
                                    checked={account.teamtalk}
                                    position="start"
                                    onChange={ev => InputAccountSave({teamtalk: ev.target.checked})}
                                />
                            }
                        </>
                    }
                    {tab === 'prompt' &&
                        <>
                            <FormGroupTitle />
                            <Textarea
                                inputStyle="underline"
                                rows={21}
                                value={account.prompt}
                                onChange={(ev) => InputAccountSave({prompt: ev.target.value})}
                            />
                        </>
                    }
                    {tab === 'ui' &&
                        <>
                            <FormGroupTitle>
                                {locale.dashboardHeaderOperations.an}
                            </FormGroupTitle>
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.ao}
                                checked={account.ui.dashboard.functions}
                                position="start"
                                onChange={ev => InputAccountSave({uiDashboardFunctions: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.ap}
                                checked={account.ui.dashboard.model}
                                position="start"
                                onChange={ev => InputAccountSave({uiDashboardModel: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.aq}
                                checked={account.ui.dashboard.override}
                                position="start"
                                onChange={ev => InputAccountSave({uiDashboardOverride: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.ar}
                                checked={account.ui.dashboard.system}
                                position="start"
                                onChange={ev => InputAccountSave({uiDashboardSystem: ev.target.checked})}
                            />
                            <FormGroupTitle>
                                {locale.dashboardHeaderOperations.as}
                            </FormGroupTitle>
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.at}
                                checked={account.ui.login.email}
                                position="start"
                                onChange={ev => InputAccountSave({uiLoginEmail: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.au}
                                checked={account.ui.login.mobile}
                                position="start"
                                onChange={ev => InputAccountSave({uiLoginMobile: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.av}
                                checked={account.ui.login.multiple}
                                position="start"
                                onChange={ev => InputAccountSave({uiLoginMultiple: ev.target.checked})}
                            />
                            <FormGroupTitle>
                                {locale.dashboardHeaderOperations.ay}
                            </FormGroupTitle>
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.aw}
                                checked={account.ui.login.title}
                                position="start"
                                onChange={ev => InputAccountSave({uiLoginTitle: ev.target.checked})}
                            />
                            <Checkbox
                                cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderOperations.ax}
                                checked={account.ui.login.forgott}
                                position="start"
                                onChange={ev => InputAccountSave({uiLoginForgot: ev.target.checked})}
                            />
                        </>
                    }
                    {tab === 'ai' &&
                        <>
                            <FormGroupTitle />
                            <div className="cs-dashboard-header-operations-helper mbsc-txt-muted">
                                <p>
                                    <a className="cs-dashboard-header-operations-links" href="#" onClick={ButtonAddPersonality}>{locale.dashboardHeaderOperations.r}</a>
                                    {'\u00A0' + locale.dashboardHeaderOperations.ba}
                                </p>
                            </div>
                            {personalities.length !== 0 &&
                                <>
                                    <FormGroupTitle>
                                        {locale.dashboardHeaderOperations.bb}
                                    </FormGroupTitle>
                                    <div className="cs-dashboard-header-operations-scroll-personality">
                                        <Listview
                                            theme="ios"
                                            themeVariant="light"
                                            select="single"
                                            itemType={ListItem}
                                            data={ListData()}
                                            onInit={(event, inst) => setListInstancePersonalities(inst)}
                                            actionsWidth={100}
                                            actions={ListActions()}
                                        />
                                    </div>
                                </>
                            }
                        </>
                    }
                    {tab === 'billing' &&
                        <>
                            <FormGroupTitle />
                            <Input
                                label={locale.dashboardHeaderOperations.bi}
                                disabled
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.billing.plan.charAt(0).toUpperCase() + account.billing.plan.slice(1)}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.bj}
                                disabled
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.billing.status.charAt(0).toUpperCase() + account.billing.status.slice(1)}
                            />
                            <Input
                                label={locale.dashboardHeaderOperations.bk}
                                disabled
                                inputStyle="underline"
                                labelStyle="inline"
                                type="text"
                                value={account.billing.users}
                            />
                            {account.billing.trial &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bl}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.billing.trial}
                                />
                            }
                            {account.billing.stripe &&
                                <FormGroupTitle>
                                    {locale.dashboardHeaderOperations.bm}
                                </FormGroupTitle>
                            }
                            {account.billing.stripe && account.stripe.customer &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bn}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.customer}
                                />
                            }
                            {account.billing.stripe && account.stripe.status &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bj}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.status}
                                />
                            }
                            {account.billing.stripe && account.stripe.subscription &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bo}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.subscription}
                                />
                            }
                            {account.billing.stripe && account.stripe.method &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bp}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.method}
                                />
                            }
                            {account.billing.stripe && account.stripe.last4 && account.stripe.brand &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bq}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.brand.charAt(0).toUpperCase() + account.stripe.brand.slice(1) + ' XXXX XXXX XXXX ' +  account.stripe.last4}
                                />
                            }
                            {account.billing.stripe && account.stripe.anchor &&
                                <Input
                                    label={locale.dashboardHeaderOperations.br}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.anchor}
                                />
                            }
                            {account.billing.stripe && account.stripe.seat &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bs}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.seat}
                                />
                            }
                            {account.billing.stripe && account.stripe.start &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bt}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={dayjs(account.stripe.start).format("MMMM D, YYYY @ h:mm A")}
                                />
                            }
                            {account.billing.stripe && account.stripe.periodStart && account.stripe.periodEnd &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bu}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={dayjs(account.stripe.periodStart).format("MMMM D, YYYY @ h:mm A") + ' - ' + dayjs(account.stripe.periodEnd).format("MMMM D, YYYY @ h:mm A")}
                                />
                            }
                            {account.billing.stripe && account.stripe.end &&
                                <Input
                                    label={locale.dashboardHeaderOperations.bv}
                                    disabled
                                    inputStyle="underline"
                                    labelStyle="inline"
                                    type="text"
                                    value={account.stripe.end}
                                />
                            }
                        </>
                    }
                </>
            }
            {!loading && ((!Empty(account) && !Empty(personality) && nav === 'accounts') || (!Empty(personality) && nav === 'personalities')) &&
                <>
                    <Input
                        label={locale.dashboardHeaderOperations.bf}
                        disabled={!personality.new}
                        inputStyle="underline"
                        labelStyle="floating"
                        type="text"
                        value={personality.value}
                        onChange={ev => InputPersonalitySave({value: ev.target.value})}
                    />
                    {nav === 'personalities' &&
                        <Input
                            label={locale.dashboardHeaderOperations.o}
                            inputStyle="underline"
                            labelStyle="floating"
                            type="text"
                            value={personality.group}
                            onChange={ev => InputPersonalitySave({group: ev.target.value})}
                        />
                    }
                    {nav === 'personalities' &&
                        <Checkbox
                            cssClass="cs-dashboard-header-operations-checkbox mbsc-bold"
                            color="info"
                            label={locale.dashboardHeaderOperations.bz}
                            checked={personality.default}
                            position="start"
                            onChange={ev => InputPersonalitySave({default: ev.target.checked})}
                        />
                    }
                    <Input
                        label={locale.dashboardHeaderOperations.bg}
                        inputStyle="underline"
                        labelStyle="floating"
                        type="text"
                        value={personality.text}
                        onChange={ev => InputPersonalitySave({text: ev.target.value})}
                    />
                    {nav === 'personalities' &&
                        <Input
                            label={locale.dashboardHeaderOperations.p}
                            inputStyle="underline"
                            labelStyle="floating"
                            type="text"
                            value={personality.textES}
                            onChange={ev => InputPersonalitySave({textES: ev.target.value})}
                        />
                    }
                    <Textarea
                        label={locale.dashboardHeaderOperations.al}
                        labelStyle="floating"
                        inputStyle="underline"
                        rows={12}
                        value={personality.prompt}
                        onChange={(ev) => InputPersonalitySave({prompt: ev.target.value})}
                    />
                </>
            }
            {!loading && !Empty(request) && tab !== 'reply' && nav === 'requests' &&
                <>
                    <Input
                        label={locale.dashboardHeaderOperations.i}
                        disabled
                        inputStyle="underline"
                        labelStyle="inline"
                        type="text"
                        value={request.user}
                    />
                    <Input
                        label={locale.dashboardHeaderOperations.k}
                        disabled
                        inputStyle="underline"
                        labelStyle="inline"
                        type="text"
                        value={request.account}
                    />
                    <Textarea
                        label={locale.dashboardHeaderOperations.y}
                        labelStyle="floating"
                        inputStyle="underline"
                        rows={3}
                        value={request.request}
                        disabled
                    />
                    {request.messages.length !== 0 &&
                        <>
                            <FormGroupTitle>
                                {locale.dashboardHeaderOperations.ad}
                            </FormGroupTitle>
                            <div className="cs-dashboard-header-operations-messages-scroll">
                                <Listview
                                    theme="ios"
                                    themeVariant="light"
                                    select="off"
                                    itemType={ListItem}
                                    data={ListData()}
                                />
                            </div>
                        </>
                    }
                </>
            }
            {!loading && !Empty(request) && tab === 'reply' && nav === 'requests' &&
                <Textarea
                    inputStyle="underline"
                    rows={6}
                    value={reply}
                    onChange={(ev) => setReply(ev.target.value)}
                />
            }
            {!loading && !Empty(error) && nav === 'errors' &&
                <>
                    <Input
                        label={locale.dashboardHeaderOperations.i}
                        disabled
                        inputStyle="underline"
                        labelStyle="inline"
                        type="text"
                        value={error.user}
                    />
                    <Input
                        label={locale.dashboardHeaderOperations.k}
                        disabled
                        inputStyle="underline"
                        labelStyle="inline"
                        type="text"
                        value={error.account}
                    />
                    <Input
                        label={locale.dashboardHeaderOperations.l}
                        labelStyle="inline"
                        inputStyle="underline"
                        value={error.app}
                        type="text"
                        disabled
                    />
                    <Input
                        label={locale.dashboardHeaderOperations.s}
                        labelStyle="inline"
                        inputStyle="underline"
                        value={error.model}
                        type="text"
                        disabled
                    />
                    <Textarea
                        label={locale.dashboardHeaderOperations.h}
                        labelStyle="floating"
                        inputStyle="underline"
                        rows={3}
                        value={error.error ? error.error : locale.dashboardHeaderOperations.q}
                        disabled
                    />
                    <Textarea
                        disabled
                        className="cs-dashboard-header-operations-code-editor-text"
                        inputStyle="underline"
                        rows={12}
                        value={JSON.stringify(error.messages, null, 2)}
                    />
                </>
            }
            <div className="mbsc-button-group-justified cs-dashboard-header-operations-nav-buttons">
                {!loading && !Empty(request) && nav === 'requests' &&
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-nav-button" onClick={() => ButtonRequestReply()} >
                        {locale.dashboardHeaderOperations.z}
                    </Button>
                }
                {!loading && ((!Empty(error) && nav === 'errors') || (!Empty(request) && nav === 'requests')) &&
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-nav-button" onClick={() => ButtonWorkspace()} >
                        {locale.dashboardHeaderOperations.d}
                    </Button>
                }
                {!loading && !Empty(error) && nav === 'errors' &&
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-nav-button" onClick={() => ButtonErrorDelete()} >
                        {locale.dashboardHeaderOperations.c}
                    </Button>
                }
                {!loading && ((!Empty(account) && nav === 'accounts') || (!Empty(request) && tab === 'reply' && nav === 'requests') || (!Empty(personality) && nav === 'personalities')) &&
                    <Button disabled={!AccountSaveCheck()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-nav-button" onClick={() => ButtonSave()} >
                        {locale.dashboardHeaderOperations.aa}
                    </Button>
                }
                {!loading && ((!Empty(account) && nav === 'accounts') || (!Empty(error) && nav === 'errors') || (!Empty(request) && nav === 'requests') || (!Empty(personality) && nav === 'personalities')) &&
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-operations-nav-button" onClick={() => ButtonBack()} >
                        {locale.dashboardHeaderOperations.n}
                    </Button>
                }
            </div>
        </Popup>
    );
}

export default DashboardHeaderOperations;
